// src/components/ChartTheme.js
// Tema de gráficos no estilo do template aprovado (material-m-nextjs dark).
// Cores: teal #00F1A7 / lime #B4F300, grid sutil, tooltip escuro, raios suaves.
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, PointElement, LineElement,
  BarElement, ArcElement, Tooltip, Legend, Filler,
} from 'chart.js';

export const CHART = {
  teal: '#00F1A7',
  tealSoft: 'rgba(0,241,167,0.20)',
  tealFade: 'rgba(0,241,167,0.08)',
  lime: '#B4F300',
  grid: 'rgba(255,255,255,0.06)',
  tick: '#93A7A3',
  text: '#E9F1EF',
  muted: '#93A7A3',
  surface: '#0A141C',
  border: 'rgba(0,241,167,0.22)',
};

export function registerCharts() {
  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend, Filler);
}

export const TOOLTIP = {
  backgroundColor: CHART.surface,
  borderColor: CHART.border,
  borderWidth: 1,
  titleColor: CHART.text,
  bodyColor: CHART.muted,
  padding: 10,
  cornerRadius: 5,
  displayColors: false,
};

export const baseOptions = () => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false }, tooltip: TOOLTIP },
  scales: {
    x: { grid: { color: CHART.grid, border: { display: false } }, ticks: { color: CHART.tick, font: { size: 12 } } },
    y: { grid: { color: CHART.grid, border: { display: false } }, ticks: { color: CHART.tick, font: { size: 12 } } },
  },
});

// Área/linha suave com gradiente (estilo do exemplo ecommerce/widgets)
export const areaOptions = (extra = {}) => ({
  ...baseOptions(),
  elements: { line: { tension: 0.4, borderWidth: 2 }, point: { radius: 0, hitRadius: 14, hoverRadius: 5 } },
  ...extra,
});

// Barras arredondadas
export const barOptions = (extra = {}) => ({
  ...baseOptions(),
  scales: {
    ...baseOptions().scales,
    x: { grid: { display: false, drawBorder: false }, ticks: { color: CHART.tick, font: { size: 12 } } },
  },
  ...extra,
});

// Donut / Pie
export const doughnutOptions = (extra = {}) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'bottom', labels: { color: CHART.muted, usePointStyle: true, pointStyle: 'circle', padding: 14, font: { size: 12 } } },
    tooltip: TOOLTIP,
  },
  cutout: '62%',
  ...extra,
});

export function areaDataset(data, color = CHART.teal) {
  return {
    data,
    borderColor: color,
    backgroundColor: (ctx) => {
      const { chart } = ctx;
      const { ctx: c, chartArea } = chart;
      if (!chartArea) return CHART.tealFade;
      const g = c.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
      g.addColorStop(0, 'rgba(0,241,167,0.34)');
      g.addColorStop(1, 'rgba(0,241,167,0)');
      return g;
    },
    fill: true,
    tension: 0.4,
    borderWidth: 2,
    pointRadius: 0,
    pointHoverRadius: 5,
  };
}

export function barDataset(data, color = CHART.teal) {
  return { data, backgroundColor: color, borderRadius: 6, borderSkipped: false, maxBarThickness: 34 };
}
